<script>
  import Divider from "./Divider.svelte";
  export let bannerData = {};
  const { HEADING, DECRIPTION } = bannerData;
</script>
<!------------------------------------------->
<!----------------MARKUP----------------------->
<!------------------------------------------->
<section class="main-bgcolor light-color" id="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-7">
        <h1>{HEADING}</h1>
        <p>{DECRIPTION}</p>
      </div>
      <div class="col-md-5">
        <img src="images/undraw_web_devices_ad58.svg" alt="" class="img-fluid" />
      </div>
    </div>
  </div>
  <Divider height="10vw" points="0,0 50,100 100,0 100,100 0,100"/>
</section>
<!------------------------------------------->
<!----------------STYLE----------------------->
<!------------------------------------------->
<style>
  section {
    padding-top: 5%;
  }

  h1 {
    font-size: 40px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .container {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  section a {
    text-decoration: none;
  }

  .wave-img {
    width: 100%;
    height: auto;
    margin-bottom: -2px;
  }
</style>